export default __webpack_public_path__ + "static/media/scan.6fec225a.m4a";